var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"va-footer"},[_c('span',{staticClass:"va-footer-text"},[_c('span',[_vm._v("© Copyright "+_vm._s(new Date().getFullYear())+" - Atticode GmbH")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }